// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f6d11cf6","239":"b6a41093","358":"e65a9006","455":"50eab246","457":"7996b83d","828":"58eb647a","893":"0b57350e"}[chunkId] + ".chunk.js";
};